import { Component, inject } from '@angular/core';

import {
  borderClasses,
  colorClasses,
  generalClasses,
  spacingClasses,
  textClasses,
} from '@demo/helper-classes/helper-classes.consts';
import { CipoFormModule } from '@shared/modules';
import { NotificationService } from '@shared/services';

@Component({
  selector: 'cipo-helper-classes',
  imports: [CipoFormModule],
  templateUrl: './helper-classes.component.html',
  styleUrl: './helper-classes.component.scss',
})
export class HelperClassesComponent {
  notify = inject(NotificationService);
  test = 'test';
  // spacings
  SPACING_CLASSES = spacingClasses;
  spacingType = 'm';
  spacingPosition = 'a';
  spacingValue = 'auto';

  // colors
  COLOR_CLASSES = colorClasses;
  colorType = 'bg';
  colorPalette = 'primary';
  hue = '900';

  // typography
  TEXT_CLASSES = textClasses;
  textType = 'cipo-text';
  textValue = 'label';

  //   borders
  BORDERS_CLASSES = borderClasses;
  borderType = '-radius';
  borderValue = 'xs';

  //   general
  GENERAL_CLASSES = generalClasses;
  generalType = 'position';
  generalValue = 'absolute';

  onTextTypeChange(value: string) {
    this.textValue = Object.keys(textClasses[value].values)[0];
  }

  onBorderTypeChange(value: string) {
    this.borderValue = Object.keys(borderClasses[value].values)[0];
  }

  onGeneralTypeChange(value: string) {
    this.generalValue = Object.keys(generalClasses[value].values)[0];
  }

  copyContent(content: string) {
    navigator.clipboard.writeText(content).then(() => this.notify.success('Copied to clipboard!'));
  }
}
